module.exports = __webpack_public_path__ + "static/media/garage.dedf33b0.svg";